import { AvailableMembershipPlan } from '@/models/api/paid-member-price/member-plan/available-membership-plan'
import { convertPlan } from '@/models/api/paid-member-price/member-plan/convert/scheme-to-model'
import { AvailablePaidMemberPlanService } from '@/services/api/paid-member-plan'

export interface AvailableMemberPlanRepository {
  listAvailables(): Promise<{ available_plans: AvailableMembershipPlan[] }>

  findBy(planId: string, subscribeId: string): Promise<AvailableMembershipPlan>
}

export class DefaultAvailableMemberPlanRepository implements AvailableMemberPlanRepository {
  constructor(private readonly planService: AvailablePaidMemberPlanService) {}

  async listAvailables(): Promise<{ available_plans: AvailableMembershipPlan[] }> {
    const response = await this.planService.list()

    return response.fold(
      (error) => {
        throw new Error(error.message)
      },
      (plans) => {
        return {
          available_plans: plans.map(convertPlan),
        }
      }
    )
  }

  async findBy(planId: string, subscribeId: string): Promise<AvailableMembershipPlan> {
    const response = await this.planService.findBy(planId, subscribeId)

    return response.fold(
      (error) => {
        throw error
      },
      convertPlan
    )
  }
}
